import { useState } from 'react';
import { Link } from 'react-router-dom';
import { games, categories } from '@/mocks/games';

export default function GameGrid() {
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const filteredGames = activeCategory === 'all'
    ? games
    : games.filter((g) => g.category === activeCategory);

  const displayGames = filteredGames.slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门火影同人游戏
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            精选最受欢迎的火影同人游戏，立即免费畅玩
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
          <button
            onClick={() => setActiveCategory('all')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
              activeCategory === 'all'
                ? 'bg-primary-500 text-white'
                : 'bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 border border-background-200/70'
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 border border-background-200/70'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {displayGames.map((game) => (
            <div
              key={game.id}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={game.image}
                  alt={game.title}
                  title={`${game.title} - 火影同人游戏`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 px-2 py-1 bg-background-900/70 backdrop-blur-sm rounded-md text-xs text-white font-medium">
                  {categories.find((c) => c.slug === game.category)?.name}
                </div>
              </div>

              <div className="p-4">
                <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base mb-2 line-clamp-1">
                  {game.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {game.description}
                </p>

                <div className="flex flex-wrap gap-1.5 mb-3">
                  {game.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-accent-100 text-accent-800 text-xs rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500"></i>
                    </div>
                    <span className="font-semibold text-foreground-800">{game.rating}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-gamepad-line"></i>
                    </div>
                    <span>{game.plays} 次游玩</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/role-playing"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 border border-background-300/60 text-foreground-700 rounded-full hover:bg-primary-50 hover:text-primary-700 hover:border-primary-300 transition-all duration-300 text-sm font-medium whitespace-nowrap no-underline cursor-pointer"
          >
            查看全部游戏
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}